import { matchService } from "../matches/matchService_v2.js";
import { identityService } from "../profile/identityService_v2.js";
import { dasModal } from "../modal_v2.js";
import { COMPUTER_NAME } from "../constants_v2.js";
import { escapeHtml } from "../escapeHtml_v2.js";
import { newMatch } from "../matches/newMatch_v2.js";
import { eventHub } from "../eventHub_v2.js";

/**
 * Renders the end of game pop up
 * for either the winner or loser
 * @param {string} winnerName
 */
const render = async () => {
  const matchResult = matchService.getCurrentMatch();
  // console.log("Inside endGamePop and matchResult is");
  // console.log(matchResult);
  if (matchResult.status != 200) {
    console.log(
      "ERROR: Can't render end of game because there is no current match.",
    );
    return;
  }

  if (!(await matchService.pAIsPlayer())) {
    // watchers don't get this
    return;
  }

  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const pAIdentity = pAIdentityResponse.identity;
  const match = matchResult.currentMatch;
  if (
    !(
      match.state === "finished" ||
      match.state === "draw" ||
      match.state === "abandonded"
    )
  ) {
    console.log(
      "ERROR: Can't render end of game because the state is: " + match.state,
    );
    return;
  }
  const winnerName = match.winnerName;
  if (typeof winnerName === "undefined") {
    console.log(
      "ERROR: Can't render end of game because the winnerName is undefined",
    );
    return;
  }
  if (winnerName.length === 0) {
    console.log(
      "ERROR: Can't render end of game because the winnerName is not populated",
    );
    return;
  }
  var messageHeader = "";
  var bodyMessage = "";
  if (pAIdentity.name === winnerName) {
    messageHeader = "Congratulations <br>" + escapeHtml(winnerName) + "!";
    bodyMessage = "You Won!";
  } else {
    messageHeader = "Game Over";
    bodyMessage = "Better luck next time. <br>Keep trying";
  }
  let wartClass = "wartzarelli";
  winnerName === COMPUTER_NAME
    ? (wartClass = "wartdelic")
    : (wartClass = "wartzarelli");
  const html = `
    <div class="flexColumn">
      <div id="eogHeader">${messageHeader}</div>
      <div id="eogBodyMessage">${bodyMessage}</div>
      <div class="${wartClass}" id="rightSide"></div>
      <div id="cta"><button id="eogCTA">Rematch</button></div>
    </div>
  `;
  dasModal.render(html);
  // in case the last move was a rotate:
  const canvas = document.getElementById("canvas");
  canvas.style.cursor = "default";
};

const handleEogCTA = async () => {
  const currentMatchResult = matchService.getCurrentMatch();
  const currentMatch = currentMatchResult.currentMatch;
  const pAIdentityResponse = await identityService.getPlayingAs();
  const pAIdentity = pAIdentityResponse.identity;

  let opponentName;
  let opponentPlayer;
  if (currentMatch.p1UserID === pAIdentity.userID) {
    opponentName = currentMatch.p2Name;
    opponentPlayer = "newSearchP2";
  }
  if (currentMatch.p2UserID === pAIdentity.userID) {
    opponentName = currentMatch.p1Name;
    opponentPlayer = "newSearchP1";
  }

  const params = {
    sendToModule: "newMatch",
    player: opponentPlayer,
    name: opponentName,
  };

  const result = newMatch.setInviteeName(params);
  dasModal.close();
};

eventHub.registerEvent("click", "eogCTA", handleEogCTA);

export const endGamePop = {
  render,
};
